<template>
		<div>
			<main style='background: #EEEEEE;'>
				<div class="fyBox">
					<!-- <div class="centerBox">
						<img src="../../assets/images/fayi_banner.jpg" alt="" class="topImg">
					</div> -->
				</div>
				<div class="topContent">
					<div class="centerBox">
						<p class="topContent_word1">法医鉴定</p>
						<p class="topContent_word2">     法医鉴定是司法程序中有关技术工作的一项重要内容。是运用医学、生物学、人类学及物理、化学等方面的知识对与人身有关的活体、尸体及生物物证等的检验鉴定工作，从而取得死亡原因、伤害程度、凶器种类、血型分析、事实确认等结论性意见</p>
					</div>
				</div>
				<div class="centerBox" style="padding:26px 0;">
					<p class="topContent_word1">鉴定机构列表</p>
					<div class="bottomContent">
						<div class="bottomContent_top">
							<a href="https://www.hkdsfjd.com/"><img src="../../assets/images/fayi_logo.jpg"  alt=""></a>

								<p class="bottomContent_topWord">      河北华科大司法鉴定中心是经河北省司法厅核准成立的综合型大型司法鉴定机构，司法鉴定许可证号：130119304，鉴定报告全国通用。中心以先进的仪器设备、经验丰富的专家团队为依托开展司法鉴定工作。鉴定业务范围包括法医病理鉴定（死亡原因分析、虚拟解剖等）、法医临床鉴定（损伤程度鉴定、伤残鉴定、三期鉴定等）、法医物证鉴定（个体识别、亲子鉴定等）、医疗损害鉴定（医疗损害后果评定、医疗过错评定、医疗过错与损害的因果关系评定）和法医毒物鉴定（人体体液中乙醇定性定量分析）。      河北华科大司法鉴定中心本着“科学、严谨、客观、公正”的服务宗旨，以人为本、质效并重、服务社会，力争成为全国司法鉴定行业中技术实力强大、服务项目全面、广大客户满意的鉴定服务机构。</p>
						</div>
						<div class="bottomContent_imgs">
							<img src="../../assets/images/fayi_01.jpg" alt="">
							<img src="../../assets/images/fayi_02.jpg" alt="">
							<img src="../../assets/images/fayi_03.jpg" alt="">
							<img src="../../assets/images/fayi_04.jpg" alt="">
						</div>
						<p v-for="(item, index) in jdfw" :key="index" class="fwxmItem">{{item}}</p>
						<!-- <div class="line"></div> -->
						<!-- <div class="bottomWorditems">
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								河北省眼科司法医学鉴定中心
							</p>
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								河北省保定精神疾病司法鉴定中心
							</p>
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								河北省张家口精神疾病司法鉴定中心
							</p>
						</div>
						<div class="bottomWorditems">
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								河北医科大学法医鉴定中心
							</p>
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								河北北方学院司法鉴定中心
							</p>
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								沧州市法医鉴定中心
							</p>
						</div>
						<div class="bottomWorditems">
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								衡水市法医鉴定中心
							</p>
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								河北盛唐司法鉴定中心
							</p>
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								海兴司法医学鉴定中心
							</p>
						</div> -->
					</div>

				</div>
			</main>
		</div>
</template>

<script>

import axios from 'axios'
import '../../assets/css/index.less'
export default {
	name: 'Pdf',
	components: {
	},
	data() {
		return {
			jdfw:[
				'鉴定服务项目',
				'法医病理鉴定',
				'法医临床鉴定',
				'法医物证鉴定',
				'法医毒物鉴定',
				'医疗损害鉴定',
				'亲子鉴定'
			],
			fayuanName: '河南省高级人民法院',
		};
	},
	methods: {
	},
	created(){

	},
	mounted() {
		let that = this;
	},
};
</script>

<style lang="less" scoped="scoped">
	.fyBox{
		width: 100%;
		height: 340px;
		box-sizing: border-box;
		background: url(../../assets/images/fayi_banner.jpg)no-repeat center;
		img{
			width: 100%;
			height: 300px;
			display: block;
			margin: 0 auto;
		}
	}
	.centerBox{
		width: 1134px;
		margin: 0 auto;
		overflow: hidden;
		box-sizing: border-box;
	}
	.topContent_word1{
		// width: 66px;
		height: 30px;
		float: left;
		line-height: 30px;
		border-bottom: 4px solid  #3DADC6;
	}
	.topContent_word2{
		margin-top: 12px;
		text-indent: 30px;
		width: 100%;
		float: left;
		text-align: justify;
		font-family: PingFangRegular;
		font-size: 16px;
		color: #000000;
		text-align: left;
		line-height: 28px;
	}

	.topContent{
		width: 100%;
		background: #fff;
		padding: 26px 0;
		box-sizing: border-box;
		overflow: hidden;
	}
	.bottomContent{
		width: 100%;
		background: #fff;
		padding: 20px;
		box-sizing: border-box;
		float: left;
		margin-top: 25px;
		padding-bottom: 60px;
	}
	.bottomContent_top{
		width: 100%;
		overflow: hidden;
		display: flex;
		    align-items: center;
		    margin-bottom: 15px;
		img{
			float: left;
		}
		.bottomContent_topWord{
			float: right;
			width: calc(100% - 350px);
			font-family: PingFangRegular;
			font-size: 16px;
			color: #000000;
			text-align: left;
			line-height: 28px;
			text-indent: 30px;
			text-align: justify;

		}
	}
	.bottomContent_imgs{
		width: 100%;
		overflow: hidden;
		margin-bottom: 20px;
		img{
			width: 23%;
			height: 190px;
			display: block;
			float: left;
			margin-right: 25px;
			&:last-of-type{
				margin-right: 0;
			}
		}
	}
	.fwxmItem{
		/* width: 13%; */
		 padding: 0 10px;
		 height: 32px;
		 line-height: 32px;
		background: #3DADC6;
		 border-radius: 5px;
		 text-align: center;
		 float: left;
		 font-size: 16px;
		 color: #fff;
		 margin-right: 15px;
		 box-sizing: border-box;
		 margin-bottom: 10px;

		&:first-of-type{
			background: none;
			color: #000;
		}
		&:last-of-type{
			margin-right: 0;
		}
	}
	.line{
		width: 100%;
		border-bottom: 2px dashed  #979797;
		margin:20px 0;
		float: left;
		margin-top: 40px;
	}
	.bottomWorditems{
		width: 100%;
		border-bottom: 1px dashed  #979797;
		overflow: hidden;
		.bottomWorditem{
			width: 33%;
			height: 47px;
			line-height: 47px;
			float: left;
			display: flex;
			align-items: center;
			img{
				float: left;
				margin-right: 10px;
			}
		}
	}
</style>
